import { IAddressWithCoordinates } from "../models/IAddressFields";
import { ILead } from "../models/Lead";

type LeadWithLocation = Pick<ILead, "vehicle">;

export function getLeadLocation(
  lead: LeadWithLocation | null | undefined
): IAddressWithCoordinates | null {
  if (!lead) return null;

  const vehicle = lead.vehicle;

  if (!vehicle) return null;

  return {
    line1: vehicle.line1 ?? null,
    line2: vehicle.line2 ?? null,
    line3: vehicle.line3 ?? null,
    line4: vehicle.line4 ?? null,
    locality: vehicle.locality ?? null,
    town: vehicle.town ?? null,
    county: vehicle.county ?? null,
    postcode: vehicle.postcode ?? null,
    latitude: vehicle.latitude ?? undefined,
    longitude: vehicle.longitude ?? undefined,
  };
}

export function getLeadPostcode(lead: LeadWithLocation | null | undefined): string {
  return getLeadLocation(lead)?.postcode ?? "";
}

export function getLeadTown(lead: LeadWithLocation | null | undefined): string {
  return getLeadLocation(lead)?.town ?? "";
}
